/**
 * 微信用户处理的工具类，此功能需要在公网环境下调试
 * 使用此工具类的页面，需要在对应的路由中配置以下属性：
 * meta : {
 *    auth : true //如果此路由需要微信授权请设置为true,默认为false
 * }
 *  可参见router/msgcenter.js 文件
 */

import Vue from 'vue';
import {Dialog, Toast} from 'vant';
import $ from "jquery";
import config from '../config/config';
import api from '../api/api';
import Storages from 'js-storage';
import jp from 'jsonpath';
import WechatAuth from './wxwork-auth';



var wxuserUtil = (function () {

  var storage = Storages.sessionStorage;
  var localStorage = Storages.localStorage;

  /**
   * 查询用户的回调函数
   * @param response
   */
  var callback4QueryUser = function (response,next, path) {
    console.log("查询用户返回",response)
    if (response.success) {
      // 企业用户对象    数据库用户对象 //
      storage.set(
        wxuserUtil.KEY_WXUSER,
        response.data.wxUser
      );
      storage.set(
        wxuserUtil.KEY_DBUSER,
        response.data.dbUser
      );
      wxuserUtil.getMenu();

      if(next){
        next(wxuserUtil.getCode(),path);
      }
    } else {
      Toast({
        message:`获取用户失败,${response.msg}`,
        duration: 1000,
        background: "#ED1B1B"
      });
      storage.set("wxUser", null);
      storage.set("dbUser", null);
      if(next){
        next();
      }
    }
  };

  /**
   * 判断是否存在用户
   * @returns {*}
   */
  var hasUser = function () {
    return storage.get(wxuserUtil.KEY_WXUSER) && storage.get(wxuserUtil.KEY_DBUSER);
  }

  /**
   * 静态字典
   * @type {{}}
   */
  var dict = {
    //用户状态
    USER_STATE : {
      ENABLED : "10", //启用
      DISABLED : "20", //禁用
      DELETED : "30" //删除
    }
  };

  /**
   * 字典KEY
   * @type {{AREA: string}}
   */
  var dictKey = {
    AREA : "Area", //经销商区域,
    ReportType : "ReportType" //报表分类
  };

  /**
   * 功能KEY
   * @type {{}}
   */
  var funcKey = {
    Audit : "Audit", //审核
    BasicCreated: "BasicCreated", //客户新增
    BasicModified: "BasicModified", //客户基础信息修改
    BasicSearch: "BasicSearch", //客户基础信息查询
    CampaingMembers: "CampaingMembers", //参与活动查询
    CourseMember: "CourseMember", //参与课程查询
    Created: "Created", //新增-所有的新增
    FollowCreated: "FollowCreated", //跟进计划新增
    FollowSearch: "FollowSearch", //跟进计划查询
    LeadCreated: "LeadCreated", //意向产品新增
    LeadModified: "LeadModified", //意向产品修改
    LeadSearch: "LeadSearch", //意向产品查询
    Modified: "Modified", //修改-所有的新增
    PRCreated: "PRCreated", //购买产品新增
    PRModified: "PRModified", //购买产品修改
    PRSearch: "PRSearch", //购买产品查询
    ReviewCreated: "ReviewCreated", //作品点评新增
    ReviewSearch: "ReviewSearch", //作品点评查询
    Search: "Search", //查询-所有的新增
    Submit: "Submit", //提交-所有的新增
    SurveyMember: "SurveyMember" //参与问卷查询
  };

  /**
   * 角色清单
   * @type {}
   */
  var roleKey = {
    sales:"sales",//销售
    Store_Manager:"Store Manager",//店长
    Sales_Advisor:"Sales Advisor",//销售顾问
    Shop_Manager:"Shop Manager",//门店店长
    Regional_Sales_Manager:"Regional Sales Manager",//区域销售经理
    DS_Manager:"DS Manager",//零售经理
    Sales_Director:"Sales Director",//销售总监
    Marketing:"Marketing",//市场部主管
    MarketingManager:"MarketingManager",//市场经理
    AK:"AK",//徕卡学院
    CRMManager:"CRMManager",//CRM管理员
    EC_Operator:"EC Operator",//电商平台运营商
    EC_Manager:"EC Manager",//电商经理
    Digital_Marketing_Director:"Digital Marketing Director",//数字营销总监
    DealerSales:"DealerSales",//经销商销售顾问
    DealerManager:"DealerManager",//经销商店长
  };

  /**
   * 路由映射到菜单
   * @type {{}}
   */
  var routerMapping = {
    "/active/list" : "24", //活动列表
    "/active/apply" : "23", //活动申请
    "/active/reportList" : "26", //活动报告列表
    "/active/activeApprove" : "24", //活动审批
    "/active/activeDetail" : "24", //活动详情
    "/active/reportApply" : "25", //活动报告申请
    "/active/reportDetail" : "26", //活动报告详情
    "/active/reportApprove" : "26", //活动报告审批
    "/active/activeRemark" : "26", //活动作品点评

    "/Client" : "12", //客户信息列表
    "/Filter" : "12", //高级搜索
    "/ClientDetails" : "12", //客户详情
    "/StayClient" : "12", //待分派客户列表
    "/StoresNumbers" : "14", //到店人数

    "/addCurriculum" : "19", //添加课程
    "/listCurriculum" : "20", //课程列表
    "/detailsCurriculum" : "20", //课程详情
    "/queryCurriculum" : "20", //课程高级查询
    "/lookProduction" : "12", //查看作品
    "/calendarCurriculum" : "20", //日历

    "/resportDetail" : "17", //销售分析表
    "/resportList" : "16", //零售报表
    "/clientCare" : "15", //客户关怀表
    "/report4SalesAnalysis" : "17" //销售分析报表
  };

  /**
   * 转换企业号配置
   */
  var convertWxConf = function () {
    var configRet = api.getDeploys();
    if(!configRet.success){
      return null;
    }
    var conf = configRet.data;
    return conf;
  };

  return {
    /**微信用户对象*/
    KEY_WXUSER : "wxUser",
    /**DB用户对象*/
    KEY_DBUSER : "dbUser",
    /**微信授权的Code*/
    KEY_CODE : "code",
    /**菜单*/
    KEY_MENU : "menu",

    storage : storage,
    localStorage : localStorage,
    funcKey : funcKey,
    dictKey : dictKey,

    /**
     * 默认选项
     */
    chooseDefList : [
      {
        name:'请选择',
        value:''
      }
    ],

    /**
     * 图片压缩选项
     */
    compressImgOptions : {
      maxWidthOrHeight : 1280
    },

    /**
     * 清除缓存
     */
    clearCache : function () {
      storage.remove([
        wxuserUtil.KEY_MENU,
        wxuserUtil.KEY_DBUSER,
        wxuserUtil.KEY_WXUSER
      ]);
    },

    /**
     * 清除部门缓存
     */
    clearDeptCache : function(){
      storage.remove([
        "reportList_deptId",
        "reportList_deptName"
      ]);
    },

    /**
     * 设置code
     */
    setCode : function (code) {
      storage.set(wxuserUtil.KEY_CODE, code);
    },

    /**
     * 获取code
     */
    getCode : function () {

      return storage.get(wxuserUtil.KEY_CODE);
    },

    /**
     * 获取菜单缓存
     * @returns {*}
     */
    getMenu(){
      let menuCache = storage.get(this.KEY_MENU);
      if(!menuCache){
        return this.queryMenu();
      }
      return menuCache;
    },

    /**
     * 判断是否有功能权限
     * @param menuId 菜单ID
     * @param srcFunc 需要判断的功能权限CODE
     * @return true 有权限 false没有权限
     */
    hasFunAuth : function(menuId,funcCode,tips,tipsTxt){
      let menuList = this.getMenu();
      console.log("hasFunAuth params,",...arguments);
      console.log("menuList",menuList);
      let func = jp.query({menu : menuList},`$..functionList[?(@.menuId==${menuId} && @.code=='${funcCode}')]`);
      let authed = func.length > 0;
      console.log("hasFunAuth Result",authed);
      if(!authed && tips){
        Toast(tipsTxt || "没有访问权限");
      }
      return authed;
    },

    /**
     * 根据路由判断是否有功能权限
     * @param path 路由地址
     * @param srcFunc 需要判断的功能权限CODE
     * @return true 有权限 false没有权限
     */
    hasFunAuthByRoute : function(path,funcCode,tips,tipsTxt){
      if(!path){
        return false;
      }
      let menuId = routerMapping[path];
      return this.hasFunAuth(menuId,funcCode,tips,tipsTxt);
    },

    /**
     * 根据路实例由判断是否有功能权限
     * @param path 路由实例
     * @param srcFunc 需要判断的功能权限CODE
     * @return true 有权限 false没有权限
     */
    hasFunAuthByRouteInst : function(route,funcCode,tips,tipsTxt){
      if(!route){
        return false;
      }
      let path = route.path;
      return this.hasFunAuthByRoute(path,funcCode,tips,tipsTxt);
    },

    /**
     *  打开个人信息页接口
     *
     * */
    openUserProfile : function(userExId){
      wx.invoke('openEnterpriseChat', {
        "externalUserIds": userExId,
        "groupName": "",
        "chatId":"",
        fail:function (res) {
          if(res.err_msg != "openUserProfile:ok") {
            //错误处理
            Dialog.alert({
              message: res.err_msg,
            }).then(() => {
              // on close
            });
          }
        }
      })
    },

    getCurExternalChat:function (fuc){
      wx.qy.getCurExternalChat ({
        success: fuc
      })
    },

    /**
     * 删除code缓存
     */
    removeCode : function () {
      storage.remove(wxuserUtil.KEY_CODE);
    },

    /**
     * 加载微信授权插件
     * @param router
     */
    loadWxAuth : function (router) {
      if(!config.wxauth){
        return ;
      }

      var that = this;
      var wxConf = convertWxConf();
      if(!wxConf){
        Toast("企业号配置查询失败");
        return ;
      }
      Vue.use(WechatAuth,{
        router, // 路由实例对象
        appid: wxConf["corpId"], // cropId
        agentid : wxConf["agentId"],//应用ID,
        corpsecret : wxConf["corpSecret"],
        scope: 'snsapi_privateinfo', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
        getCodeCallback (code, next,path) {
          // 用户同意授权后回调方法
          // code：用户同意授权后，获得code值
          // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
          // next： 无论access_token是否获取成功,一定要调用该方法
          // next说明：next方法接收两个参数
          // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
          // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
          wxuserUtil.queryUser(code,next,path);
        }
      });
    },

    /**
     * 初始化微信SDK配置
     */
    initWxSdk : function () {
        var _defaultApi = [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          'openEnterpriseChat',
          "onMenuShareQZone",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "showMenuItems",
          "hideMenuItems",
          "hideOptionMenu",
          "showOptionMenu",
          "scanQRCode",
          "getCurExternalContact",
          "getContext"
        ];
        var _jsApi = window["__GLOBAL_WXJSSDK_API"] || _defaultApi;
       var ret = api.postSync("api/wxwork/sign",{
         url :  window.location.href
       });
        if(ret.success){
          var wxSign = ret.data;
          var wxConf=convertWxConf()

          wx.config({
            beta : true,
            //debug: true,
            appId : wxConf["corpId"],
            timestamp : wxSign["timestamp"],
            nonceStr : wxSign["noncestr"],
            signature : wxSign["signature"],
            jsApiList : _jsApi
          });
        }
    },

    /**
     * 分享事件
     * @param commmonVariable 公共的分享变量
     * @param success 成功的回调方法
     * @param cancel 返回的的回调函数
     */
    share : function(commmonVariable,success,cancel){
      commmonVariable = commmonVariable || {};
      if(!commmonVariable["desc"]){
        commmonVariable["desc"] = commmonVariable["title"];
      }

      /**
       * 回调方法定义
       */
      var _callback = {
        success: function () {
          if(typeof(success) == "function"){
            success();
          }
        },
        cancel: function () {
          if(typeof(cancel) == "function"){
            cancel();
          }
        }
      };


      wx.ready(function(){
        //分享到朋友圈
        var _shareTimeLine = $.extend(true,{},commmonVariable,_callback);
        wx.onMenuShareTimeline(_shareTimeLine);

        //转发
        var _shareAppMessage = $.extend(true,{},commmonVariable,_callback);
        wx.onMenuShareAppMessage(_shareAppMessage);

        //分享到微信
        var shareWeixin = $.extend(true,{},commmonVariable,_callback);
        wx.onMenuShareWechat(shareWeixin);
      });
    },
    uploadImage:function(localIds,successCall,fail){
      var localId = localIds.pop();
      wx.uploadImage({
            localId: localId.toString(),//需要上传的图片的本地ID
            isShowProgressTips: 1,//默认是1，显示进度提示
            success: function (res) {
                var serverIdRes = res.serverId;//返回图片的服务器端
                api.uploadFileWx({
                  mediaIds:serverIdRes
                }).then(Response => {
                  if(successCall!=null){
                    successCall(Response)
                  }
                }).catch(err=>{
                  if(fail!=null){
                      fail(err)
                  }

                })
            },
            fail: function (res) {
                if(fail!=null){
                    fail(err)
                }
            }
        });
    },
    /**
     * 初始化微信SDK配置
     */
    initWxAgentSdk : function () {
      var _defaultApi = [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone",
        "chooseImage",
        "previewImage",
        "uploadImage",
        "downloadImage",
        "openEnterpriseChat",
        "showMenuItems",
        "hideMenuItems",
        "hideOptionMenu",
        "showOptionMenu",
        "scanQRCode",
        "getCurExternalContact",
        "getContext"
      ];
      var _jsApi = window["__GLOBAL_WXJSSDK_API"] || _defaultApi;

      return new Promise((resolve, reject) => {
      	var ret = api.postSync("api/wxwork/sign",{
      	  url :  window.location.href
      	});
      	if(ret.success){
      	  var wxSign = ret.data;
      	  var wxConf=convertWxConf()
          wx.config({
            beta : true,
            debug: false,
            appId : wxConf["corpId"],
            timestamp : wxSign["timestamp"],
            nonceStr : wxSign["noncestr"],
            signature : wxSign["signature"],
            jsApiList : _jsApi
          });

          wx.ready(function(){
            console.log('wx***agentConfig',wx.agentConfig);
              wx.agentConfig({
                  corpid: wxConf["corpId"], // 必填，企业微信的corpid，必须与当前登录的企业一致
                  agentid: wxConf["agentId"], // 必填，企业微信的应用id （e.g. 1000247）
                  timestamp:wxSign["timestamp"] , // 必填，生成签名的时间戳
                  nonceStr: wxSign["noncestr"], // 必填，生成签名的随机串
                  signature: wxSign['signatureAgent'],// 必填，签名，见附录-JS-SDK使用权限签名算法
                  jsApiList: ['selectExternalContact','getCurExternalContact'], //必填
                  success: function(res) {
                    resolve(res);
                    console.log('agentConfig成功：',res);
                  },
                  fail: function(res) {
                    reject(res);
                    console.log('agentConfig：',res);
                    //alert('agentConfig失败:'+JSON.stringify(res));
                      // if(res.errMsg.indexOf('function not exist') > -1){
                      //     alert('版本过低请升级')
                      // }
                  }
              });

          });
          // setTimeout(function () {

          // },500);

        }
      })
    },

    //获取外部联系人userId
    getCurExternalContact:function(successCall,fail){
      console.log('wx',wx.invoke);
      wx.invoke('getCurExternalContact', {},
        function(res){
          //alert('getCurExternalContact:'+JSON.stringify(res));
          console.log('getCurExternalContact:',res);
          if(res.err_msg == "getCurExternalContact:ok"){
              let userId  = res.userId ; //返回当前外部联系人userId
              successCall(userId)
          }else {
            fail(res)//错误处理
          }
        }
      );
    },

    /**
     * 根据code查询用户详细信息
     * @param next
     * @param path
     */
    queryUser : function (code,next,path) {
      if(hasUser()){
        return ;
      }
      if (code) {
        callback4QueryUser(api.getSync("api/wxwork/userDetail",{ code: code }),next, path);
      }else{
        //获取模拟用户数据
        if(config["mockUser"]){
          callback4QueryUser(api.getSync("api/wxwork/userDetailMock",{u : "tangyong"}));
        }
      }
    },

    /**
     * 查询菜单
     */
    queryMenu(){
      if(!hasUser()){
        return ;
      }
      var menuRes = api.getMenuListSync({salesId:this.getUserId()});
      if(menuRes.success){
        storage.set(this.KEY_MENU,menuRes.data);
      }
      return menuRes.data || [];
    },


    /**
     * 是否是模拟用户
     * @returns {*}
     */
    isMockUser : function () {
      return config["mockUser"];
    },

    /**
     * 获取微信用户对象
     */
    getWxUserObj : function () {
      return storage.get(wxuserUtil.KEY_WXUSER) || {};
    },

    /**
     * 获取用户对象
     */
    getUserObj : function () {
      return storage.get(wxuserUtil.KEY_DBUSER) || {};
    },

    /**
     * 获取用户ID
     * @returns {*|string}
     */
    getUserId : function () {
        return this.getUserObj()["U_UserId"] || "";
    },

    /**
     * 获取用户姓名
     * @returns {*|string}
     */
    getUserName : function () {
      return this.getUserObj()["Name"] || "";
    },

    /**
     * 获取用户手机号码
     * @returns {*|string}
     */
    getMobile : function () {
      return this.getUserObj()["U_Mobile"] || "";
    },

    /**
     * 获取部门名称
     * @returns {*|string}
     */
    getDeptName : function () {
      return this.getUserObj()["deptName"] || "";
    },

    /**
     * 获取部门ID
     * @returns {*|string}
     */
    getDeptId : function () {
      return this.getUserObj()["deptId"] || "";
    },

    /**
     * 获取部门区域
     * @returns {*|string}
     */
    getDeptArea : function () {
      return this.getUserObj()["deptArea"] || "";
    },

    /**
     * 获取用户角色
     * @returns {*|string}
     */
    getRole : function () {
      return this.getUserObj()["U_Position"] || "";
    },

    /**
     * 判断是否是销售总监
     * @returns {boolean}
     */
    isSalesDirector(){
      return this.getUserObj()["isRoleSalesDirector"] || false;
    },

    /**
     * 判断是否是门店店长
     * @returns {*|boolean}
     */
    isRoleShopManager(){
      return this.getUserObj()["isRoleShopManager"] || false;
    },

    /**
     * 获取用户状态
     * @returns {*|string}
     */
    getUserStatus : function () {
      return this.getUserObj()["U_Status"] || "";
    },

    /**
     * 获取部门税率
     * @returns {*|number}
     */
    getDeptTaxRate : function () {
      return this.getUserObj()["taxRate"] || 0;
    },

    /**
     * 判断用户是否是正常状态
     * @returns {boolean}
     */
    isEnable : function () {
      return dict.USER_STATE.ENABLED == this.getUserStatus();
    },

    /**
     * 验证上传的文件是否是图片
     * @param file
     * @returns {boolean}
     */
    validateIsImg(file){
      if(!file){
        return true;
      }
      var fileType = file.type || "";

      var isImg = fileType.startsWith("image/") ? true : false;
      if(!isImg){
        Toast("只允许上传图片");
      }

      return isImg;
    },
    //判断是否是微信
    isWeixin : function () {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    }

  }
})();


export default wxuserUtil;



// WEBPACK FOOTER //
// ./src/common/wxuserUtil.js